export class DecimalToHex {
    public static convert(number) {
        return  number.toString(16).padStart(6,"0").padStart(7,"#").toUpperCase();
    }
}